import {Controller} from "stimulus"
import $ from 'jquery';
import {get} from "@rails/request.js";


export default class extends Controller {
    static targets = ["dashboard", "filters", 'modalSpec', 'specification']

    connect() {
        this.get_dashboard_stats()
    }

    update_view() {
        this.get_dashboard_stats()
    }

    get_dashboard_stats() {
        if (this.hasDashboardTarget) {
            $(this.dashboardTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Actualizando datos del dahsboard.</div>`)

            setTimeout(() => {
                get(`/admin/fuel/get_dashboard_data`, {
                    query: {
                        target: this.dashboardTarget.id,
                        filter: JSON.stringify(this.get_filters())
                    },
                    responseKind: "turbo-stream"
                }).then()
            }, 1000)

        }
    }

    get_filters() {
        let filters = {}
        if (this.hasFiltersTarget) {
            let parentElement = $(this.filtersTarget)
            let selects = parentElement.find('select')
            let input = parentElement.find('input[type="text"]');
            let input_hidden = parentElement.find('input[type="hidden"]');
            let checkbox = parentElement.find('input[type="checkbox"]');

            input.map((index, elem) => {
                if (!elem.value.isEmpty() && !elem.name.isEmpty()) {
                    filters[elem.name] = elem.value
                }
            })
            input_hidden.map((index, elem) => {
                if (!elem.value.isEmpty() && !elem.name.isEmpty()) {
                    filters[elem.name] = elem.value
                }
            })

            selects.map((index, elem) => {
                console.log(elem)
                if (!elem.value.isEmpty()) {
                    filters[elem.name] = elem.value
                }
            })


            checkbox.map((index, elem) => {
                if (!elem.name.isEmpty()) {
                    filters[elem.name] = elem.checked
                }
            })


        }
        return filters;
    }

    clearFilter(e) {
        let parentElement = $(`#${e.target.dataset.target}`);
        let input = parentElement.find('input[type="text"]');
        let input_hidden = parentElement.find('input[type="hidden"]');
        let select = parentElement.find('select');

        input.map((index, elem) => {
            elem.value = '';
        })
        input_hidden.map((index, elem) => {
            elem.value = '';
        })
        select.map((index, elem) => {
            $(elem).val(null).trigger('change');
        })
    }

    specification(e) {
        if (this.hasSpecificationTarget) {
            $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)
        }

        this.modal = new bootstrap.Modal(this.modalSpecTarget, {
            keyboard: false,
            backdrop: 'static',
            focus: true
        })

        this.modal.show();

        setTimeout(() => {
            if (this.hasSpecificationTarget) {
                $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)


                get(`/admin/fuel/get_specification`, {
                    query: {
                        target: this.specificationTarget.id,
                        type: e.target.dataset.type,
                        filter: JSON.stringify(this.get_filters())
                    },
                    responseKind: "turbo-stream"
                }).then()
            }
        }, 1000)
    }

    transfer_fuel() {
        if (this.hasSpecificationTarget) {
            $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)
        }

        this.modal = new bootstrap.Modal(this.modalSpecTarget, {
            keyboard: false,
            backdrop: 'static',
            focus: true
        })

        this.modal.show();

        setTimeout(() => {
            if (this.hasSpecificationTarget) {
                $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)


                get(`/admin/fuel/get_transfers`, {
                    query: {
                        target: this.specificationTarget.id,
                        filter: JSON.stringify(this.get_filters())
                    },
                    responseKind: "turbo-stream"
                }).then()
            }
        }, 1000)
    }

    external_movements() {
        if (this.hasSpecificationTarget) {
            $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)
        }

        this.modal = new bootstrap.Modal(this.modalSpecTarget, {
            keyboard: false,
            backdrop: 'static',
            focus: true
        })

        this.modal.show();

        setTimeout(() => {
            if (this.hasSpecificationTarget) {
                $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)


                get(`/admin/fuel/get_external_movements`, {
                    query: {
                        target: this.specificationTarget.id,
                        filter: JSON.stringify(this.get_filters())
                    },
                    responseKind: "turbo-stream"
                }).then()
            }
        }, 1000)
    }

    administrative_movements() {
        if (this.hasSpecificationTarget) {
            $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)
        }

        this.modal = new bootstrap.Modal(this.modalSpecTarget, {
            keyboard: false,
            backdrop: 'static',
            focus: true
        })

        this.modal.show();

        setTimeout(() => {
            if (this.hasSpecificationTarget) {
                $(this.specificationTarget).html(`<div class="mt-5 d-flex justify-content-center align-items-center flex-column" style="gap: 15px;"><span class="fa fa-circle-o-notch fa-spin fa-3x" style="color: #268adc;"></span> Cargando datos.</div>`)


                get(`/admin/fuel/get_administrative_movements`, {
                    query: {
                        target: this.specificationTarget.id,
                        filter: JSON.stringify(this.get_filters())
                    },
                    responseKind: "turbo-stream"
                }).then()
            }
        }, 1000)
    }

    modal_hide() {
        this.modal.hide()
    }
}